/*
Created by marcin on 2015-09-28 - 12:05.
*/
class ApiLogin {
    static init() {
        //Login
        if ($('.login-content')[0]) {
            //Add class to HTML. This is used to center align the login box
            $('html').addClass('login-content');

            $('body').on('click', '.login-navigation > li', function () {
                const z = $(this).data('block');
                const t = $(this).closest('.lc-block');

                t.removeClass('toggled');

                setTimeout(function () {
                    $(z).addClass('toggled');
                });

            });
        }
    }
}
